import humanizeDuration from 'humanize-duration';
import { useRouter } from 'next/router';


export default function Time({ time }) {
  const router = useRouter();

  const { locale } = router;

  const shortEnglishHumanizer = humanizeDuration.humanizer({
    language: locale,
    languages: {
      en: { y: () => 'y', mo: () => 'mo', w: () => 'w', d: () => 'd', h: () => 'hr', m: () => 'min', s: () => 'sec', ms: () => 'ms', },
      fr: { y: () => 'y', mo: () => 'mois', w: () => 'w', d: () => 'jours', h: () => 'h', m: () => 'min', s: () => 's', ms: () => 'ms', },
      es: { y: () => 'y', mo: () => 'mo', w: () => 'w', d: () => 'd', h: () => 'h', m: () => 'min', s: () => 's', ms: () => 'ms', },
      pt: { y: () => 'y', mo: () => 'mo', w: () => 'w', d: () => 'd', h: () => 'h', m: () => 'min', s: () => 's', ms: () => 'ms', },
      zh: { y: () => 'y', mo: () => 'mo', w: () => 'w', d: () => 'd', h: () => '小时', m: () => '分钟', s: () => '秒', ms: () => 'ms', },
      ru: { y: () => 'г', mo: () => 'м', w: () => 'н', d: () => 'в', h: () => 'ч', m: () => 'мин', s: () => 'сек', ms: () => 'мс', },
      units: ["m", "s"]
    },
  });

  return (
    <>
      {shortEnglishHumanizer(time * 1000)}
    </>
  )
}